import { render } from "./PostSearchModal.vue?vue&type=template&id=eb54a7e8&ts=true"
import script from "./PostSearchModal.vue?vue&type=script&lang=ts"
export * from "./PostSearchModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__